import React, { useEffect, useRef } from 'react';
import ReactClampLines from 'react-clamp-lines';
import PropTypes from 'prop-types';
/*
  * creating for ADA. for some reason react clamp lines uses aria-hidden on text, making it inaccessible to screenreaders
  * this HOC corrects for that
*/
const ClampLines = (props) => {
  const { text } = props;
  const ref = useRef(null);

  useEffect(
    () => {
      const els = ref.current?.querySelectorAll("div[aria-hidden='true']");
      els?.forEach(
        (el) => el.setAttribute('aria-hidden', false)
      );
    }
  );

  if (!text) return null;

  return (
    <div ref={ref}>
      <ReactClampLines
        {...props}
      />
    </div>
  );
};

ClampLines.displayName = 'ClampLines';
ClampLines.propTypes = {
  text: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  lines: PropTypes.number,
};

ClampLines.defaultProps = {
  lines: 3,
};

export default ClampLines;
